import React from 'react';

class ComponentErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error in component:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <div className="text-danger">{this.props.componentErrorMessage || 'Error in component.'}</div>;
        }

        return this.props.children;
    }
}

export default ComponentErrorBoundary;
